import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()
  const isHome = location.pathname === '/'

  const scrollToSection = (id: string) => {
    if (!isHome) {
      window.location.href = `/#${id}`
      return
    }
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
    setMobileMenuOpen(false)
  }

  return (
    <header
      className="content-container"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        padding: '14px 20px',
        background: 'color-mix(in srgb, var(--color-bg) 92%, transparent)',
        backdropFilter: 'blur(6px)',
        borderBottom: '1px solid var(--color-divider)'
      }}
    >
      <Link
        to="/"
        style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          fontSize: '20px',
          letterSpacing: '.14em',
          padding: '2px 10px',
          background: 'var(--color-accent-900)',
          color: 'var(--color-bg)',
          textDecoration: 'none',
          cursor: 'pointer'
        }}
      >
        TALLY
      </Link>

      <nav className="hidden md:flex" style={{ alignItems: 'center', gap: '22px', fontFamily: 'var(--font-heading)', fontWeight: 600, fontSize: '14px' }}>
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => scrollToSection('how-it-works')}
        >
          How it works
        </span>
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => scrollToSection('benefits')}
        >
          Benefits
        </span>
        <Link
          to="/faq"
          style={{ color: 'inherit', textDecoration: 'none' }}
        >
          FAQ
        </Link>
      </nav>

      <Link to="/contact" className="btn btn-primary" style={{ minHeight: '42px', fontSize: '14px' }}>
        Book a demo
      </Link>

      <button
        className="md:hidden"
        style={{ padding: '8px', background: 'none', border: 'none', cursor: 'pointer' }}
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {mobileMenuOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {mobileMenuOpen && (
        <div
          className="md:hidden"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: 'var(--color-bg)',
            borderBottom: '1px solid var(--color-divider)',
            padding: '16px 20px'
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontFamily: 'var(--font-heading)', fontWeight: 600, fontSize: '14px' }}>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => scrollToSection('how-it-works')}
            >
              How it works
            </span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => scrollToSection('benefits')}
            >
              Benefits
            </span>
            <Link
              to="/faq"
              style={{ color: 'inherit', textDecoration: 'none' }}
              onClick={() => setMobileMenuOpen(false)}
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              className="btn btn-primary"
              style={{ minHeight: '42px', fontSize: '14px', textAlign: 'center' }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Book a demo
            </Link>
          </div>
        </div>
      )}
    </header>
  )
}
